import { BasePageModel, basePageToLocal } from './base';
import {
  ReferenceNode,
  Reference,
  referenceNodeToLocal,
  referenceNodeToServer
} from './parameter';
import {
  InputParameter,
  inputParameterToLocal,
  inputParameterToServer
} from './data-query';

import { SourceType } from '@config/index';

import {
  TriggerCondition,
  ActionChannel,
  conditionToLocal,
  channelsToLocal,
  conditionToServer,
  channelsToServer
} from './index';


export interface StateUpdateUpdateFuncArgumentConfig {
  nextStateUpdates?: StateUpdateInfo[];
  nextDelStateUpdates?: StateUpdateInfo[];
  nextDelStateUpdate?: StateUpdateInfo;
  nextRevertStateUpdateId?: string;
}

export enum StateUpdateTriggerMethod {
  Event = 'event',
  Condition = 'condition',
  State = 'state',
  Fallback = 'fallback'
}

export enum StateUpdateStrategy {
  SetNull = 'set_null',
  Value = 'value',
  OtherSlot = 'other_slot',
  FunctionCall = 'function_call',
  CodeExpression = 'code_expression'
}

export type StateUpdateAction = {
  strategy: StateUpdateStrategy;
  value?: string;
  otherSlot?: Reference;
  function?: Reference;
  parameters?: InputParameter[];
  codeExpression?: string;
};

export enum StateUpdateTriggerType {
  Init = 'init',
  ValueCheckFail = 'value_check_fail'
}

export type StateUpdateEventState = {
  targetSlot?: Reference;
  codeExpression: string;
};

export type StateUpdateState = {
  slot?: Reference;
  state: string;
};

export enum StateUpdateRuleMethod {
  ClearValue = 'clear_value',
  Assignment = 'assignment'
}

export type StateUpdateRule = {
  targetSlot?: Reference;
  method: StateUpdateRuleMethod;
  codeExpressions: string[];
};

export type StateUpdateInfo = BasePageModel & {

  // rules: StateUpdateRule[];

  triggerMethod: StateUpdateTriggerMethod;
  event?: ReferenceNode;
  eventStates: StateUpdateEventState[];
  conditionType: SourceType;
  conditions: TriggerCondition[];
  conditionCode: string;
  codeComment?: string;
  stateConfig?: StateUpdateState;
  triggerTiming?: Reference;
  channels: ActionChannel[];
  masterSelf?: StateUpdateInfo;

  // for local use
  dirty?: boolean;
};

function stateUpdateActionToLocal(res: any): StateUpdateAction {

  return {
    strategy: res.strategy,
    value: res.value,
    otherSlot: res.other_slot && res.other_slot.map(referenceNodeToLocal),
    function: res.function && res.function.map(referenceNodeToLocal),
    parameters: res.parameters && res.parameters.map(inputParameterToLocal),
    codeExpression: res.code_expression
  };
}

function stateUpdateEventStateToLocal(res: any): StateUpdateEventState {

  return {
    targetSlot: res.target_slot && res.target_slot.map(referenceNodeToLocal),
    codeExpression: res.code_expression
  };
}

function stateUpdateEventStateToServer(data: StateUpdateEventState) {

  return {
    target_slot: data.targetSlot && data.targetSlot.map(referenceNodeToServer),
    code_expression: data.codeExpression
  };
}

function stateUpdateRuleToLocal(res: any): StateUpdateRule {

  return {
    targetSlot: res.target_slot && res.target_slot.map(referenceNodeToLocal),
    method: res.method,
    codeExpressions: res.code_expressions
  };
}

function stateUpdateRuleToServer(data: StateUpdateRule) {

  return {
    target_slot: data.targetSlot && data.targetSlot.map(referenceNodeToServer),
    method: data.method,
    code_expressions: data.codeExpressions
  };
}

export function stateUpdateInfoToLocal(res: any): StateUpdateInfo {

  return {
    ...basePageToLocal(res),
    triggerMethod: res.trigger_method,
    event: referenceNodeToLocal(res.event),
    eventStates: (res.event_states || []).map(stateUpdateEventStateToLocal),
    conditionType: res.condition_type || SourceType.CODE_EXPRESSION,
    conditions: (res.conditions || []).map(conditionToLocal),
    conditionCode: res.condition_code,
    codeComment: res.code_comment,
    stateConfig: res.state_config && {
      slot: res.state_config.slot && res.state_config.slot.map(referenceNodeToLocal),
      state: res.state_config.state
    },
    triggerTiming: res.trigger_timing && res.trigger_timing.map(referenceNodeToLocal),
    channels: channelsToLocal(res.channels),
    masterSelf: res.master_self && stateUpdateInfoToLocal(res.master_self)
  };
}


export function stateUpdateInfoToServer(data: StateUpdateInfo): any {

  return {
    name: data.name,
    trigger_method: data.triggerMethod,
    event: referenceNodeToServer(data.event),
    event_states: (data.eventStates || []).map(stateUpdateEventStateToServer),
    condition_type: data.conditionType,
    conditions: (data.conditions || []).map(conditionToServer),
    condition_code: data.conditionCode,
    code_comment: data.codeComment,
    state_config: data.stateConfig && {
      slot: data.stateConfig.slot && data.stateConfig.slot.map(referenceNodeToServer),
      state: data.stateConfig.state
    },
    trigger_timing: data.triggerTiming && data.triggerTiming.map(referenceNodeToServer),
    channels: channelsToServer(data.channels)
  };
}
